import { useEffect, useState } from 'react';
import {
  DESKTOP_MAX_WIDTH,
  DESKTOP_MIN_WIDTH,
  LAPTOP_MAX_WIDTH,
  LAPTOP_MIN_WIDTH,
  MOBILE_MAX_WIDTH,
  MOBILE_MIN_WIDTH,
  TABLET_MAX_WIDTH,
  TABLET_MIN_WIDTH,
  TV_MAX_WIDTH,
  TV_MIN_WIDTH,
} from 'shared/styles/breakpoints';

const isInRange = (width: number, minWidth: number, maxWidth: number) => {
  return width >= minWidth && width <= maxWidth;
};

const useWindowSize = () => {
  const { innerWidth, innerHeight } = window;
  const [windowSize, setWindowSize] = useState({ width: innerWidth, height: innerHeight });

  const [isMobile, setIsMobile] = useState(false);
  const [isNotMobile, setIsNotMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isNotTablet, setIsNotTablet] = useState(false);
  const [isLTLaptop, setIsLTLaptop] = useState(false);
  const [isLaptop, setIsLaptop] = useState(false);
  const [isLTDesktop, setIsLTDesktop] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);
  const [isTv, setIsTv] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      setIsMobile(isInRange(window.innerWidth, MOBILE_MIN_WIDTH, MOBILE_MAX_WIDTH));
      setIsNotMobile(isInRange(window.innerWidth, TABLET_MIN_WIDTH, TV_MAX_WIDTH));
      setIsTablet(isInRange(window.innerWidth, TABLET_MIN_WIDTH, TABLET_MAX_WIDTH));
      setIsNotTablet(isInRange(window.innerWidth, LAPTOP_MIN_WIDTH, TV_MAX_WIDTH));
      setIsLTLaptop(isInRange(window.innerWidth, 0, TABLET_MAX_WIDTH));
      setIsLaptop(isInRange(window.innerWidth, LAPTOP_MIN_WIDTH, LAPTOP_MAX_WIDTH));
      setIsLTDesktop(isInRange(window.innerWidth, 0, LAPTOP_MAX_WIDTH));
      setIsDesktop(isInRange(window.innerWidth, DESKTOP_MIN_WIDTH, DESKTOP_MAX_WIDTH));
      setIsTv(isInRange(window.innerWidth, TV_MIN_WIDTH, TV_MAX_WIDTH));
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { windowSize, isMobile, isNotMobile, isTablet, isNotTablet, isLTLaptop, isLaptop, isLTDesktop, isDesktop, isTv };
};

export default useWindowSize;
